import { render, staticRenderFns } from "./AddProfileModal.vue?vue&type=template&id=19baedd0&"
import script from "./AddProfileModal.vue?vue&type=script&lang=js&"
export * from "./AddProfileModal.vue?vue&type=script&lang=js&"
import style0 from "./AddProfileModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports